module.exports = __webpack_public_path__ + "images/media-kit-1-ceb33acf6ac7da8094160e133196c032.jpg";